module.exports = __webpack_public_path__ + "img/recommendLogo3.bb089d35.png";